import { RcTrans } from '@/components/atoms/RcTrans'
import { RcButton } from '@/components/molecules/interactive/RcButton'
import { RcIconButton } from '@/components/molecules/interactive/RcIconButton'
import { useChat } from '@/components/providers/site/ChatProvider'
import { useIsMobile } from '@/core/hooks/useMediaQueries'
import { useChatTicket } from '@/entity/chat/useChatTicket'
import { useCompetitionChannel } from '@/entity/competition/useCompetitionChannel'
import Tooltip from '@mui/material/Tooltip'

export const CompetitionChatButton = () => {
  const isMobile = useIsMobile()
  const buttonSize = isMobile ? 'small' : 'medium'
  const { channel } = useCompetitionChannel()
  const { handleJoinChat } = useChatTicket()
  const { handleShowChat } = useChat()

  if (!channel) return null

  const handleClick = async () => {
    await handleJoinChat(channel)
    handleShowChat(channel?.socialId)
  }

  return (
    <Tooltip title={<RcTrans i18nKey='competition:rc-competition-chat' />}>
      {isMobile ? (
        <RcIconButton
          size={buttonSize}
          IconProps={{ size: 'xs' }}
          icon={['fal', 'message-plus']}
          onClick={handleClick}
        />
      ) : (
        <RcButton variant='outlined' onClick={handleClick}>
          <RcTrans i18nKey='competition:rc-competition-chat' />
        </RcButton>
      )}
    </Tooltip>
  )
}
